import React from 'react'
import EmptyProjectPreviewImage from '~/assets/projects/empty_project_preview.png'

export const ProjectItemPreview = () => (
  <img src={EmptyProjectPreviewImage} className="project-item__image" alt="thumbnail" />
)
